import React from "react";
import { CONSTANTS } from "../../constants/app-constant";
const { DATA_NOT_FOUND } = CONSTANTS;
const PopperContentField = ({ label, value = DATA_NOT_FOUND }) => {
  return (
    <p>
      <label>{label}: </label> <span>&nbsp;{value || DATA_NOT_FOUND}</span>
    </p>
  );
};
export default React.memo(PopperContentField);
